const gql = {
  query: `query getPhoneList {
    getPhoneList {
      success
      data {
        taAccounts {
          phoneList {
            formData
            textData {
              areaCode
              ext
              type
              phoneNumberType
              phoneNumber
            }
          }
        }
        tracAccounts {
          phoneList {
            formData
            textData {
              areaCode
              ext
              type
              phoneNumberType
              phoneNumber
            }
          }
        }
      }
    }
  }
  `,
  meta: {
    label: "Get Phone List",
  },
};

export default gql;
